/*
 *
 * TechnicalErrorModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 07-Nov-2024
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: <PortalMessage id='t.app.technicalErrorModal.title' defaultMessage='Non è stato possibile proseguire per un problema tecnico' />,
  buttonLabel: <PortalMessage id='t.app.okUnderstood' defaultMessage='Ok, ho capito' />
}

export default formattedMessage
